import { AbstractLifeCycle } from '@datadog/browser-core';
export var LifeCycle = (AbstractLifeCycle);
//# sourceMappingURL=lifeCycle.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@datadog/browser-logs/esm/domain/lifeCycle.js
// module id = null
// module chunks = 